import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import { useLocation } from '@reach/router'

import MuiBreadCrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { Theme } from '@mui/material/styles'

const cleanupName = (name: string) => {
  const newName = name.replaceAll('-', ' ')
  return newName.charAt(0).toUpperCase() + newName.slice(1)
}

const styles = {
  root: ({ breakpoints }: Theme) => ({
    marginBottom: '44px',

    '& .MuiBreadcrumbs-separator': {
      marginLeft: '5px',
      marginRight: '5px',
    },
    '& .MuiBreadcrumbs-li:last-child > p': {
      color: 'common.black',
    },

    [breakpoints.down('sm')]: {
      root: {
        marginBottom: '24px',
      },
    },
  }),
}

type Breadcrumbs = {
  path?: string
}

const Breadcrumbs = ({ path }: Breadcrumbs) => {
  const { pathname } = useLocation()

  const pathnames = path ? path.split('/').filter(x => x) : pathname.split('/').filter(x => x)

  return (
    <MuiBreadCrumbs aria-label="breadcrumb" maxItems={4} itemsAfterCollapse={2} sx={styles.root}>
      {pathnames.map((name, index) => {
        const goTo = `/${pathnames.slice(0, index + 1).join('/')}`
        const lastItem = index === pathnames.length - 1
        return lastItem ? (
          <Typography key={index} variant="body2">
            {cleanupName(name)}
          </Typography>
        ) : (
          <Link key={index} variant="body2" component={GatsbyLink} to={goTo}>
            {cleanupName(name)}
          </Link>
        )
      })}
    </MuiBreadCrumbs>
  )
}

export default Breadcrumbs
